import { brand } from "../consts/brand"

export type Docs = {
  facsimile: string
  foglioInformativo: string
  guidaABF: string
  centraleRischi: string
  tegmAntiusura: string
  informativaPrivacy: string
  informativaSic: string
  biometricDisclosure: string
  termsAndConditions: string
  ibanGuide: string
  policy231: string
}

export const getDocsByClientSource = (): Docs => {
  return {
    foglioInformativo: `${brand.websiteUrl}/wp-content/uploads/2026/04/Foglio-informativo-n.-11-Digital.pdf`,
    guidaABF: `${brand.websiteUrl}/wp-content/uploads/2022/01/ABF-in-parole-semplici.pdf`,
    centraleRischi: `${brand.websiteUrl}/wp-content/uploads/2023/02/Guida-sulla-centrale-dei-rischi_22-dicembre-2021.pdf`,
    tegmAntiusura: `${brand.websiteUrl}/wp-content/uploads/2025/10/cs-ril-trim-antiusura-30.09.2025.pdf`,
    informativaPrivacy: `${brand.websiteUrl}/wp-content/uploads/2025/07/Informativa-trattamento-dei-dati-personali-nellambito-del-Digital-Lending.pdf`,
    informativaSic: `${brand.websiteUrl}/wp-content/uploads/2026/04/Informativa-sui-sistemi-di-informazioni-creditizie-SIC.pdf`,
    facsimile: `${brand.staticUrl}/contratto-finanziamento-digital-lending.pdf`,
    biometricDisclosure: `${brand.staticUrl}/informativa_trattamento_dati_biometrici.pdf`,
    termsAndConditions: `${brand.staticUrl}/contratto-termini-condizione-piattaforma.pdf`,
    policy231: `${brand.staticUrl}/All.1-Informativa_ai_sensi_231-07.pdf`,
    ibanGuide: `${brand.staticUrl}/Guida_Estratto_Conto_BancaCF%2B.pdf`
  }
}
